{
  "name": "@adornis/buchungsheld",
  "displayName": "Adornis Starter Kit",
  "description": "Base for everything",
  "version": "3.0.0",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-build project --deployPath /app/workspaces/buchungsheld/dist --listenPort 3000 --nodePort 7000",
    "start": "adornis-build project start --no-production --inspect-port 9222",
    "test": "adornis-build project test --no-production --code-coverage --inspect-port 9222"
  },
  "license": "ISC",
  "@adornis/esbuild": {
    "server-path": "src/server",
    "client-path": "src/client",
    "print-path": "src/print-components",
    "standalone-path": "src/standalone-components",
    "node-worker-path": "./src/node-workers",
    "output-path": "dist",
    "loadFile": [
      "ico"
    ]
  }
}
